import { Controller } from "@hotwired/stimulus";

// Keeps the install button in step with the checked rows.
//
// UI state only: it writes a count into a badge and toggles a disabled class.
// All copy, pluralization and markup come from the server.
export default class extends Controller {
  static targets = ["checkbox", "count", "submit", "emptyHint"];

  connect() {
    this.refresh();
  }

  refresh() {
    const selected = this.checkboxTargets.filter((checkbox) => checkbox.checked).length;

    this.countTargets.forEach((target) => {
      target.textContent = String(selected);
    });

    this.submitTargets.forEach((submit) => {
      submit.disabled = selected === 0;
    });

    this.emptyHintTargets.forEach((hint) => {
      hint.classList.toggle("hidden", selected > 0);
    });
  }

  selectAll() {
    this.#setAll(true);
  }

  selectNone() {
    this.#setAll(false);
  }

  #setAll(checked) {
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = checked;
    });
    this.refresh();
  }
}
